module.exports = __webpack_public_path__ + "img/google-play.791674df.jpg";